import React from 'react';
import styles from './ManagerCalendarWorkingHoursItem.module.scss';
import CheckboxField from '../../../../../../Components/Form/components/CheckboxField';
import FormCondition from '../../../../../../Components/Form/FormCondition';
import FormContainer from '../../../../../../Components/Form/FormContainer';
import TimePickerField from '../../../../../../Components/Form/components/TimePickerField/TimePickerField';
import Text from '../../../../../../Components/Base/Text/Text';

interface Props {
	name: string;
	title: string;
}

const ManagerCalendarWorkingHoursItem: React.FC<Props> = ({ name, title }) => {
	const timePickerStyle: React.CSSProperties = {
		marginBottom: 0,
		width: '100px',
	};

	return (
		<FormContainer name={name}>
			<div className={styles.item}>
				<div className={styles.checkboxWrapper}>
					<CheckboxField name='active' />
					<Text tx={title} className={styles.title} />
				</div>
				<FormCondition controlName='active' equal={true}>
					<div className={styles.dayParts}>
						<FormContainer name='morning'>
							<div className={styles.times}>
								<Text tx='base.shared.from' />
								<TimePickerField name='timeFrom' style={timePickerStyle} />
								<Text tx='base.shared.to' />
								<TimePickerField name='timeTo' style={timePickerStyle} />
							</div>
						</FormContainer>
						<div className={styles.line} />
						<FormContainer name='afternoon'>
							<div className={styles.times}>
								<Text tx='base.shared.from' />
								<TimePickerField name='timeFrom' style={timePickerStyle} />
								<Text tx='base.shared.to' />
								<TimePickerField name='timeTo' style={timePickerStyle} />
							</div>
						</FormContainer>
					</div>
				</FormCondition>
			</div>
		</FormContainer>
	);
};

export default ManagerCalendarWorkingHoursItem;
